/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import "./DesignServicePromo.scss";

export default function DesignServicePromo({ onDesignServiceClicked, ...restProps }) {
  function handleDesignServiceClick(e) {
    onDesignServiceClicked?.();
  }

  return (
    <div {...restProps} className={cn("design-service-promo scope-812a63cf", restProps.className)}>
      <span className="design-service-promo__text scope-812a63cf">
        {" "}
        Need edits? Use our <strong className="scope-812a63cf">FREE</strong>{" "}
        <a
          className="design-service-promo__link scope-812a63cf"
          href="#"
          onClick={e => {
            e.preventDefault();
            handleDesignServiceClick(e);
          }}
          data-testid="design-service-promo-link"
        >
          <strong className="scope-812a63cf">design service!</strong>
        </a>
      </span>
    </div>
  );
}
